import { render, staticRenderFns } from "./Italy.vue?vue&type=template&id=e27d8e2c&"
import script from "./Italy.vue?vue&type=script&lang=js&"
export * from "./Italy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e27d8e2c')) {
      api.createRecord('e27d8e2c', component.options)
    } else {
      api.reload('e27d8e2c', component.options)
    }
    module.hot.accept("./Italy.vue?vue&type=template&id=e27d8e2c&", function () {
      api.rerender('e27d8e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Italy.vue"
export default component.exports